import { render, staticRenderFns } from "./ModalRespostasWhatsapp.vue?vue&type=template&id=0c58b4d6&scoped=true&"
import script from "./ModalRespostasWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ModalRespostasWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./ModalRespostasWhatsapp.vue?vue&type=style&index=0&id=0c58b4d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58b4d6",
  null
  
)

export default component.exports